import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Section, Container, Eyebrow, DisplayH1 } from "@/components/Layout";
import { api } from "@/lib/api";
import { Play } from "lucide-react";

export default function University() {
  const [courses, setCourses] = useState([]);
  useEffect(() => { api.get("/courses").then((r) => setCourses(r.data.courses || [])); }, []);
  return (
    <>
      <Section testid="university-hero" className="pt-40 pb-16">
        <Container>
          <Eyebrow>Online University · Global</Eyebrow>
          <DisplayH1 className="mt-6 max-w-4xl">The library that never closes.</DisplayH1>
          <p className="mt-8 max-w-2xl text-lg text-[color:var(--wk-bone-dim)] leading-relaxed">
            Four opening courses. More being filmed inside our Chicago studios. Each course is
            paired with an AI tutor, weekly office hours, and a digital certificate.
          </p>
        </Container>
      </Section>
      <Section testid="university-list" className="pb-28">
        <Container>
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {courses.map((c) => (
              <Link key={c.course_id} to={`/university/${c.course_id}`} className="card-lux overflow-hidden group">
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img src={c.image} alt="" className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-110" />
                  <div className="absolute inset-0 cinema-overlay" />
                  <div className="absolute top-4 left-4 overline text-[10px] px-3 py-1 rounded-full glass border-white/20">{c.level}</div>
                  <Play className="absolute bottom-4 right-4 text-white/80" size={22} />
                </div>
                <div className="p-6">
                  <div className="text-xs text-[color:var(--wk-gold)]">{c.duration}</div>
                  <div className="mt-3 font-serif-display text-2xl leading-tight">{c.title}</div>
                  <div className="text-sm text-[color:var(--wk-bone-dim)] mt-2">{c.instructor}</div>
                  <p className="text-sm text-[color:var(--wk-bone-dim)] mt-3 leading-relaxed">{c.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </Section>
    </>
  );
}
